import Request from '../../../gd/data/request'

import HourlyCostHistory from "../hourly-rate-history/hourly-cost-history"

// const debug = "ApiHourlyRateHistory"
const debug = false

export default class ApiHourlyRateHistory {

    static create(history:HourlyCostHistory) {
        debug && console.log(debug, "create")
        return new Request(this, 'POST', 'hourly-rate-history/create', history.toJSON())
    }

    static update(history:HourlyCostHistory) {
        debug && console.log(debug, "update")

        return new Request(this, 'PUT', 'hourly-rate-history/'+history.id, history.updatedFieldsToJSON())
    }

    static delete(history:HourlyCostHistory) {
        debug && console.log(debug, "delete")
        return new Request(this, 'DELETE', 'hourly-rate-history/'+history.id)
    }

    static selectAll() {
        return new Request(this, 'GET', 'hourly-rate-history/select-all')
    }
}
